import React from "react";

const DAY = 86400000;
// Listings not re-confirmed within this many days show a "re-confirming availability" note.
// The daily sweep re-walks the full corpus on a ~2-3 day rotation (bounded per-state depth), so
// this threshold sits just above that cycle to avoid flagging listings mid-rotation.
export const RECONFIRM_DAYS = 4;

export function isReconfirming(lastSeen) {
  if (!lastSeen) return false;
  const ts = new Date(lastSeen).getTime();
  if (!ts || Number.isNaN(ts)) return false;
  return (Date.now() - ts) / DAY > RECONFIRM_DAYS;
}

export function FreshnessNote({ lastSeen, agingOnly = false, className = "" }) {
  if (!lastSeen) return null;
  const ts = new Date(lastSeen).getTime();
  if (!ts || Number.isNaN(ts)) return null;
  const reconfirming = (Date.now() - ts) / DAY > RECONFIRM_DAYS;
  if (agingOnly && !reconfirming) return null;
  const dateStr = new Date(lastSeen).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  return (
    <div
      data-testid={reconfirming ? "reconfirming-note" : "verified-as-of"}
      className={`font-mono-data text-[10px] uppercase tracking-wider inline-flex items-center gap-1.5 ${reconfirming ? "text-amber-500" : "text-muted-foreground/70"} ${className}`}
      title={reconfirming
        ? "This listing hasn't been re-confirmed against the verified source in the last couple of days — we're re-verifying its availability before it's fully removed."
        : "Availability confirmed against the verified source on this date."}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${reconfirming ? "bg-amber-500 animate-pulse" : "bg-emerald-500/60"}`} />
      {reconfirming ? `Re-confirming availability · last verified ${dateStr}` : `Verified as of ${dateStr}`}
    </div>
  );
}

export default FreshnessNote;
